import ReferralSourceStatusCard from 'routes/ReferralSourceAnalytics/ReferralSourceStatusCard/ReferralSourceStatusCard';

export default ReferralSourceStatusCard;
